import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=516c34a6&scoped=true&"
import script from "./SplashScreen.vue?vue&type=script&lang=ts&"
export * from "./SplashScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=516c34a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c34a6",
  null
  
)

export default component.exports